export const getDayDifference = (date1: Date, date2: Date): number => {
  date1 = new Date(date1);
  date1.setHours(0, 0, 0, 0);
  date2 = new Date(date2);
  date2.setHours(0, 0, 0, 0);
  return Math.floor((date2 - date1) / (24 * 3600 * 1000));
}